import profitShareElements from "./profit-share-elements";
import baselineSignOff from "./baseline-sign-off";
import baselineMeetingDeterminations from "./baseline-meeting-determinations";
import {showErrorNotification, showSuccessNotification} from "../../global/notifications";
import distributionBonusPlan from "./distribution-bonus-plan";

const _id = $('[name=Id]').val();
export default function () {
    //Run profit share elements
    profitShareElements();

    // Run Section Functions
    baselineSignOff(_id);
    baselineMeetingDeterminations(_id);
    distributionBonusPlan(_id, "#distribution-base-bonus-plan");
    distributionBonusPlan(_id, "#distribution-final-bonus-plan");

    saveFormEvent();
}

const saveFormEvent = () => {
    const $saveButton = $('#saveButton')
    $saveButton.unbind('click');
    $saveButton.bind('click', function () {
        const $this = $(this);
        $this.attr('disabled', true)
        saveForm()
            .then(msg => showSuccessNotification(msg))
            .catch(error => showErrorNotification(error))
            .finally(() => {
                $this.attr('disabled', false)
            })
    });

}

const saveForm = () => {
    return new Promise((resolve, reject) => {
        const k_projectedStartDate = $('[name="ProjectedStartDate"]').data('kendoDatePicker');
        const k_projectedCompletionDate = $('[name="ProjectedCompletionDate"]').data('kendoDatePicker');
        const k_projectedTeamGpPercent = $('[name="ProjectTeamGpPercent"]').data('kendoNumericTextBox');
        const k_gpStartIncentivePercent = $('[name="GpStartIncentivePercent"]').data('kendoNumericTextBox');
        const k_bonusPotential = $('select.js-bonus-potential').data('kendoDropDownList');

        let data = {
            Id: _id,
            ContractValue: $('[name="ContractValue"]').data('value'),
            ProjectedStartDate: k_projectedStartDate ? kendo.toString(k_projectedStartDate.value(), "MM/dd/yyyy H:mm") : null,
            ProjectedCompletionDate: k_projectedCompletionDate ? kendo.toString(k_projectedCompletionDate.value(), "MM/dd/yyyy H:mm") : null,
            ProjectedGpPercent: $('[name="ProjectedGpPercent"]').data('value'),
            ProjectTeamGpPercent: k_projectedTeamGpPercent ? k_projectedTeamGpPercent.value() / 100 : null,
            GpStartIncentivePercent: k_gpStartIncentivePercent ? k_gpStartIncentivePercent.value() / 100 : null,
            BonusPotential: k_bonusPotential.value() ?? 0.25,
            Comment: $('textarea[name="comment"]').val()
        };

        $.post('/Operations/ProfitShare/SaveProfitShare', data, function (response) {
            if (response.success) {
                resolve(response.message);
            } else {
                reject(response.message);
            }
        });
    });
}